/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showindicator1Inputs */

const en_entity_showindicator1 = /** @type {(inputs: Entity_Showindicator1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Indicator`)
};

const de_entity_showindicator1 = /** @type {(inputs: Entity_Showindicator1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indikator anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Indicator" |
*
* @param {Entity_Showindicator1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showindicator1 = /** @type {((inputs?: Entity_Showindicator1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showindicator1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showindicator1(inputs)
	return de_entity_showindicator1(inputs)
});
export { entity_showindicator1 as "entity_showIndicator" }